module.exports = {
  // ToDo: Figure it out why sectionStatus is defined here?
  sectionStatus: {
    currentTaking: 'CTK',
    pending: 'PND',
    submitted: 'SUB',
  },
  chatbotConversationName: {
    BEFORE_TEST: 'before_test',
    DURING_TEST: 'during_test',
    AFTER_TEST: 'after_test',
  },
  environment:
    'PLT' /* @Todo need to add this to store after we integrate this project to embed */,
  codeEditorLibraryUrl: process.env.REACT_APP_CODE_EDITOR_LIBRARY_URL,
  baseUrl:
    JSON.parse(process.env.REACT_APP_BASE_URL_MAP || '{}')[location.host] ||
    process.env.REACT_APP_BASE_URL,
  nimbusHost: process.env.REACT_APP_NIMBUS_HOST,
  doWebSocketServiceHost: process.env.REACT_APP_DO_WEBSOCKET_SERVICE_HOST,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  externalProxyUrl: process.env.REACT_APP_EXTERNAL_PROXY_URL,
  chatbotApiUrl: process.env.REACT_APP_CHAT_BOT_API_URL,
  chatbotFileUploadUrl: process.env.REACT_APP_CHAT_BOT_FILE_UPLOAD_URL,
  chatbotFormKey: 'F49ug4f6l07e18',
  chatbotSystemId: 'DOSELECTCHATBOT',
  chatbotScreenshotFormat: 'webp',
  proctorExternalBaseUrl: process.env.REACT_APP_PROCTOR_EXTERNAL_API_HOST,
  whiteLabelEnabled:
    JSON.parse(process.env.REACT_APP_BASE_URL_MAP || '{}')[location.host] !==
    process.env.REACT_APP_BASE_URL,
};
